import React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import CustomSelect from '../../ui/CustomSelect';

const periodOptions = [
  { value: 'monthly', label: 'Bulanan' },
  { value: 'quarterly', label: 'Triwulan' },
  { value: 'yearly', label: 'Tahunan' },
];

const unitOptions = [
  { value: '%', label: '% (Persen)' },
  { value: 'Rp', label: 'Rp (Rupiah)' },
  { value: 'Unit', label: 'Unit' },
  { value: 'Orang', label: 'Orang' },
  { value: 'Jam', label: 'Jam' },
  { value: 'Hari', label: 'Hari' },
  { value: 'Bulan', label: 'Bulan' },
  { value: 'Tahun', label: 'Tahun' },
  { value: 'Kali', label: 'Kali' },
  { value: 'Dokumen', label: 'Dokumen' },
  { value: 'Proyek', label: 'Proyek' },
  { value: 'Transaksi', label: 'Transaksi' },
];

export default function KPIModal({
  open,
  form,
  setForm,
  departments,
  editing,
  saving,
  onClose,
  onSave,
}) {
  if (!open) return null;

  const deptOptions = [
    { value: '', label: 'Pilih departemen (opsional)' },
    ...(departments || []).map(d => ({ value: String(d.id), label: d.name })),
  ];

  return createPortal(
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4">
      <div className="bg-white rounded-lg w-full max-w-lg max-h-[90vh] overflow-hidden animate-modal">
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="text-lg font-semibold">{editing ? 'Edit KPI' : 'Tambah KPI Baru'}</h3>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-4 space-y-3 max-h-[60vh] overflow-y-auto">
          <div className="space-y-1">
            <label className="text-sm font-medium text-gray-700">
              Nama KPI <span className="text-red-500">*</span>
            </label>
            <input
              value={form.name}
              onChange={e => setForm({ ...form, name: e.target.value })}
              placeholder="Nama KPI"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
            />
          </div>
          <div className="space-y-1">
            <label className="text-sm font-medium text-gray-700">Departemen</label>
            <CustomSelect
              value={form.department_id ? String(form.department_id) : ''}
              onChange={val => setForm({ ...form, department_id: val })}
              options={deptOptions}
              placeholder="Pilih departemen (opsional)"
              width="w-full"
            />
          </div>
          <div className="grid grid-cols-3 gap-4">
            <div className="space-y-1">
              <label className="text-sm font-medium text-gray-700">Target</label>
              <input
                type="number"
                value={form.target_value}
                onChange={e => setForm({ ...form, target_value: e.target.value })}
                placeholder="0"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
              />
            </div>
            <div className="space-y-1">
              <label className="text-sm font-medium text-gray-700">Satuan</label>
              <CustomSelect
                value={form.unit || '%'}
                onChange={val => setForm({ ...form, unit: val })}
                options={unitOptions}
                placeholder="Pilih satuan"
                width="w-full"
              />
            </div>
            <div className="space-y-1">
              <label className="text-sm font-medium text-gray-700">Bobot (%)</label>
              <input
                type="number"
                value={form.weight}
                onChange={e => setForm({ ...form, weight: e.target.value })}
                placeholder="0"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
              />
            </div>
          </div>
          <div className="space-y-1">
            <label className="text-sm font-medium text-gray-700">Periode</label>
            <CustomSelect
              value={form.period}
              onChange={val => setForm({ ...form, period: val })}
              options={periodOptions}
              placeholder="Pilih periode"
              width="w-full"
            />
          </div>
          <div className="space-y-1">
            <label className="text-sm font-medium text-gray-700">Deskripsi</label>
            <textarea
              value={form.description}
              onChange={e => setForm({ ...form, description: e.target.value })}
              placeholder="Deskripsi KPI..."
              rows={3}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500 resize-none"
            />
          </div>
        </div>
        <div className="flex justify-end gap-3 p-4 border-t bg-gray-50">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100 font-medium"
          >
            Batal
          </button>
          <button
            onClick={onSave}
            disabled={saving || !form.name}
            className="px-4 py-2 bg-emerald-600 text-white rounded-md hover:bg-emerald-700 disabled:opacity-50 font-medium"
          >
            {saving ? 'Menyimpan...' : 'Simpan'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
